import {
  CollapsedIcon,
  ExpandedIcon,
  type IconProps,
} from '@carboncopyco/icons';
import { Badge, TextBase, TooltipBubble } from '@carboncopyco/ui';
import * as Accordion from '@radix-ui/react-accordion';
import type React from 'react';
import { useRef } from 'react';

type FolderTreeRowProps = {
  icon: React.ReactElement<IconProps>;
  name: string;
  isOrigin: boolean;
} & (
  | { hasContent: boolean; isOpen: boolean }
  | { hasContent?: false; isOpen?: never }
);

export const FolderTreeRow = ({
  icon,
  name,
  hasContent = false,
  isOpen,
  isOrigin,
}: FolderTreeRowProps) => {
  const anchorRef = useRef<HTMLDivElement>(null);

  return (
    <div className="flex items-center">
      <div className="w-6 shrink-0">
        {hasContent && (
          <Accordion.Trigger>
            {isOpen ? <ExpandedIcon /> : <CollapsedIcon />}
          </Accordion.Trigger>
        )}
      </div>
      <div className="flex items-center gap-3 grow truncate">
        <div className="shrink-0">{icon}</div>
        <TooltipBubble
          anchorRef={anchorRef}
          title={name}
          placement="top-end"
          delay={[1000, 0]}
        />
        <div
          ref={anchorRef}
          className="truncate text-ds-natural-600 grow"
        >
          <TextBase
            color="text-ds-natural-600"
            label={name}
          />
        </div>
        {isOrigin && (
          <Badge
            variant="blue"
            label="current"
          />
        )}
      </div>
    </div>
  );
};
